// import {
//   useGetPatientLatestSnapshot,
//   useGetPatientSnapshotSummaryItems,
// } from "@elation/api-client/src/stitch-api";
import { Text } from "@src/components/general/Text";
import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import { MarkdownRenderer } from "@src/components/markdown/MarkdownRenderer";
// import { useCurrentPatient } from "@src/stores/app";
// import { useMemo } from "react";
import styles from "./Snapshot.module.less";

export const Snapshot = () => {
  // TODO: wire up to stitch-web snapshot endpoint when available
  // const currentPatient = useCurrentPatient();
  //
  // const { data: snapshotData } = useGetPatientLatestSnapshot(
  //   currentPatient?.id ?? -1,
  //   {
  //     query: {
  //       enabled: !!currentPatient?.id,
  //     },
  //   },
  // );
  //
  // const { data: summaryItemsData, isFetching: isFetchingSummaryItems } =
  //   useGetPatientSnapshotSummaryItems(
  //     currentPatient?.id ?? -1,
  //     snapshotData?.data?.id ?? -1,
  //     {
  //       query: {
  //         enabled: !!currentPatient?.id && !!snapshotData?.data?.id,
  //       },
  //     },
  //   );
  //
  // const markdown = useMemo(() => {
  //   if (isFetchingSummaryItems) {
  //     return new Array(5)
  //       .fill(null)
  //       .map((_) => `- :::loading height=10 width=400:::\n`)
  //       .join("\n");
  //   }
  //
  //   return (
  //     summaryItemsData?.data.map((item) => `- ${item.text}`).join("\n") ?? ""
  //   );
  // }, [summaryItemsData, isFetchingSummaryItems]);

  return (
    <VerticalFlexbox className={styles.root}>
      <Text appearance="system" className={styles.header}>
        SNAPSHOT
      </Text>
      <MarkdownRenderer markdown="" />
    </VerticalFlexbox>
  );
};
